import React from "react";
import OrganizerApplicationsList from "./OrganizerApplicationsList";

const OrganizersPage = () => {
  return (
    <div className="space-y-6">
      {/* Header */}
      <div>
        <h1 className="text-2xl font-bold text-gray-800 dark:text-gray-100">
          Organizer Management
        </h1>
        <p className="text-gray-600 dark:text-gray-400 mt-1">
          Manage organizers and applications
        </p>
      </div>

      {/* Content */}
      <div className="mt-6">
        <OrganizerApplicationsList />
      </div>
    </div>
  );
};

export default OrganizersPage;
